(function() {
    var buttonsOpen = document.querySelectorAll('[data-open-notification]');
    var buttonsClose = document.querySelectorAll('customer-notifications-container .halo-sidebar-header');
    var containerNotification = document.querySelector('customer-notifications-container');
    var body = document.querySelector('body');

    function loadNotificationImages() {
      const container = document.querySelector('customer-notifications-container');
      if (!container) return;
      const images = container.querySelectorAll('img[data-notification-src]');
      images.forEach(img => {
        const dataSrc = img.getAttribute('data-notification-src');
        if (dataSrc) {
          // Verifica se a imagem ainda não foi carregada (ainda tem o placeholder SVG)
          const currentSrc = img.src || '';
          if (!currentSrc.includes(dataSrc) && (currentSrc.includes('data:image/svg+xml') || currentSrc === '')) {
            img.src = dataSrc;
            img.removeAttribute('data-notification-src');
          }
        }
      });
    }

    function show() {
      body.classList.add('notifications-sidebar-show');
      // Carrega as imagens quando o sidebar é aberto
      setTimeout(function() {
        loadNotificationImages();
      }, 50);
    }

    function hide() {
      body.classList.remove('notifications-sidebar-show');
    }

    if (buttonsOpen.length && containerNotification) {
      buttonsOpen.forEach(button => {
        button.addEventListener('click', function () {
          show();
          if (document.body.classList.contains('menu_open')) {
            document.body.classList.remove('menu_open');
          }
        });
      });

      if (buttonsClose.length) {
        buttonsClose.forEach(button => {
          button.addEventListener('click', function () {
            hide();
          });
        });
      }

      body.addEventListener('click', function (event) {
        if (body.classList.contains('notifications-sidebar-show')) {
          if (!event.target.closest('#halo-notification-sidebar') && !event.target.closest('[data-open-notification]')) {
            hide();
          }
        }
      });
    }
})();
